<template>
    <div class="container">
        <o-bread-crumb>
            <template v-slot:pageName>Voucher</template>
            <template v-slot:pageDetail>List</template>
        </o-bread-crumb>

        <FeatureGate featureKey="point_control">
        <div v-if="thisComponentShow" class="card text-center bg-white shadow-none">
            <div class="card-header border-bottom-0 pb-0">
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">
                            <h4 class="header-title">
                                <i class="fas fa-ticket-alt me-2 text-primary"></i>List of Vouchers
                            </h4>
                        </div>
                        <p class="header-subtitle mt-1">Manage created vouchers</p>
                    </li>
                </ul>
            </div>
            <div class="card-body">
                <div class="" v-if="page.output">
                    <div class="filter-action-wrapper mb-4 mt-3">
                        <div class="filter-controls">
                            <!-- Search Control -->
                            <div class="search-box-custom">
                                <div class="search-type-tabs">
                                    <button 
                                        v-for="opt in searchOptions" 
                                        :key="opt.value"
                                        class="tab-btn" 
                                        :class="{ active: searchSelected === opt.value }"
                                        @click="searchSelected = opt.value"
                                    >
                                        {{ opt.text }}
                                    </button>
                                </div>
                                <div class="search-input-wrapper" v-if="searchSelected === 'name'">
                                    <input 
                                        type="text" 
                                        class="form-control-search" 
                                        v-model="searchCriteria" 
                                        placeholder="Search by name..." 
                                        @keyup.enter="doSearch()" 
                                    />
                                    <button v-if="!isSearchActive" class="btn-search" @click="doSearch()">
                                        <i class="fas fa-search"></i>
                                    </button>
                                    <button v-else class="btn-search" @click="clearSearch()">
                                        <i class="fas fa-times text-danger"></i>
                                    </button>
                                </div>
                                <div class="search-input-wrapper" v-if="searchSelected === 'tier'">
                                    <select class="form-select custom-select-transparent" v-model="searchCriteria" @change="doSearch()">
                                        <option value="">Select Tier</option>
                                        <option v-for="t in tierList" :key="t.value" :value="t.text">{{ t.text.length > 25 ? t.text.substring(0, 25) + '..' : t.text }}</option>
                                    </select>
                                    <button v-if="isSearchActive" class="btn-search" @click="clearSearch()">
                                        <i class="fas fa-times text-danger"></i>
                                    </button>
                                </div>
                                <div class="search-input-wrapper" v-if="searchSelected === 'voucher_type'">
                                    <select class="form-select custom-select-transparent" v-model="searchCriteria" @change="doSearch()">
                                        <option value="">Select Type</option>
                                        <option value="credit_discount">Credit Discount</option>
                                        <option value="product_service">Product & Service</option>
                                    </select>
                                    <button v-if="isSearchActive" class="btn-search" @click="clearSearch()">
                                        <i class="fas fa-times text-danger"></i>
                                    </button>
                                </div>
                                <div class="search-input-wrapper" v-if="searchSelected === 'status'">
                                    <select class="form-select custom-select-transparent" v-model="searchCriteria" @change="doSearch()">
                                        <option value="">Select Status</option>
                                        <option value="Active">Active</option>
                                        <option value="Expired">Expired</option>
                                        <option value="Out of Stock">Out of Stock</option>
                                    </select>
                                    <button v-if="isSearchActive" class="btn-search" @click="clearSearch()">
                                        <i class="fas fa-times text-danger"></i>
                                    </button>
                                </div>
                            </div>
                            <!-- Merchant filter -->
                            <div class="status-filter-box" v-if="selectedBusinessProfile.merchant_id == '' || selectedBusinessProfile.merchant_id == null">
                                <div class="custom-merchant-dropdown" ref="merchantDropdownRef">
                                    <button 
                                        type="button" 
                                        class="dropdown-trigger-btn" 
                                        @click="toggleMerchantDropdown"
                                        :title="selectedMerchantText"
                                    >
                                        <span class="trigger-text">{{ selectedMerchantText }}</span>
                                        <i class="fas fa-chevron-down trigger-icon" :class="{ 'is-active': isMerchantDropdownOpen }"></i>
                                    </button>

                                    <div class="dropdown-menu-popover" v-if="isMerchantDropdownOpen">
                                        <div class="dropdown-search-box">
                                            <i class="fas fa-search search-box-icon"></i>
                                            <input 
                                                type="text" 
                                                ref="merchantSearchInputRef"
                                                v-model="merchantSearchQuery"
                                                class="dropdown-search-input"
                                                placeholder="Type merchant name..."
                                                @input="merchantRenderLimit = 10"
                                            />
                                            <button 
                                                v-if="merchantSearchQuery" 
                                                type="button" 
                                                class="search-clear-btn"
                                                @click="merchantSearchQuery = ''; merchantRenderLimit = 10"
                                            >
                                                <i class="fas fa-times"></i>
                                            </button>
                                        </div>

                                        <div class="dropdown-options-list" @scroll="onMerchantListScroll">
                                            <div 
                                                v-for="m in visibleMerchants" 
                                                :key="m.value"
                                                class="dropdown-option-item"
                                                :class="{ 'is-selected': selectMerchant === m.value }"
                                                @click="selectMerchantOption(m.value)"
                                            >
                                                <span class="option-text" :title="m.text">{{ m.text }}</span>
                                                <i v-if="selectMerchant === m.value" class="fas fa-check option-check-icon"></i>
                                            </div>

                                            <div v-if="filteredMerchants.length === 0" class="dropdown-empty-state">
                                                No merchant found
                                            </div>

                                            <div v-if="visibleMerchants.length < filteredMerchants.length" class="dropdown-load-more-hint">
                                                Scroll for more ({{ filteredMerchants.length - visibleMerchants.length }} remaining)
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="action-section">
                            <div class="action-buttons-group">
                                <button class="btn btn-refresh" @click.prevent="resetState()" title="Refresh">
                                    <i class="fas fa-sync-alt"></i>
                                </button>
                                <router-link v-if="write" :to="{ name: 'VoucherForm' }" class="btn btn-add">
                                    <i class="fas fa-plus me-1"></i> Add New
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <o-table style="text-align:left;" class="table-hover voucher-list-table">
                        <thead>
                            <tr>
                                <td class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                                    {{ field }}
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in vouchers" :key="index" class="voucher-row-clickable">
                                <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>

                                <td><span :title="item.name">{{ truncate(item.name, 20) }}</span></td>
                                <td>
                                    <span class="badge text-dark text-capitalize" :class="item.voucher_type === 'credit_discount' ? 'status-active' : 'status-primary'">
                                        {{ item.voucher_type === 'credit_discount' ? 'Credit Discount' : 'Product & Service' }}
                                    </span>
                                </td>
                                <td>{{ item.point }}</td>
                                <td>{{ item.is_limited ? item.stock : "Unlimited" }}</td>
                                <td>
                                    <span v-if="item.voucher_type === 'product_service'" class="badge text-dark text-capitalize status-default">N/A</span>
                                    <span v-else-if="item.min_transaction > 0">Rp {{ Number(item.min_transaction).toLocaleString('id-ID') }}</span>
                                    <span v-else class="badge text-dark text-capitalize status-info">No Minimum</span>
                                </td>
                                <td>{{ item.member_tier_id ? item.tier_name : 'All Tiers' }}</td>
                                <td>
                                    <div class="modern-date">
                                        <span class="date-main">{{ formatDateOnly(item.expiration) }}</span>
                                        <span class="time-sub"><i class="far fa-clock"></i> {{ formatTimeOnly(item.expiration) }}</span>
                                    </div>
                                </td>
                                <td>
                                    <span class="badge text-dark text-capitalize" :class="getStatusClass(item)">
                                        {{ getStatus(item) }}
                                    </span>
                                </td>
                                <td class="ml-3">
                                    <div class="d-flex gap-2">
                                        <template v-if="write">
                                            <template v-if="isMerchantLevel && isCorporateVoucher(item)">
                                                <span class="badge-readonly-action">
                                                    <i class="fas fa-lock me-1"></i> Corporate
                                                </span>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <router-link class="btn btn-action btn-edit" :to="{ name: 'VoucherEdit', params: { id: item.id } }">
                                                        <i class="fas fa-edit me-1"></i> Edit
                                                    </router-link>
                                                </div>
                                                <div>
                                                    <a href="#" class="btn btn-action btn-delete" @click.prevent="confirmDelete(item)">
                                                        <i class="fas fa-trash-alt me-1"></i> Delete
                                                    </a>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="vouchers.length === 0">
                                <td colspan="9" class="text-center">No vouchers available</td>
                            </tr>
                        </tbody>
                    </o-table>
                </div>
            </div>
            
            <div class="container mt-5">
                <o-pagination :page="meta.page"  :total="meta.total" @callback="navPage"/>
            </div>
        </div>
        </FeatureGate>
    </div>
    <div class="d-flex justify-content-center spinner-border text-primary spinner-position" v-if="page.isLoading"></div>
    <div class="spinner" v-if='page.isLoading'></div>
    <br>

    <o-warning-box
        v-if="isDeleteConfirmVisible"
        title="Delete Voucher"
        :item-name="itemToDelete?.name || 'this voucher'"
        warning-message="This action cannot be undone."
        confirm-text="Yes, Delete"
        cancel-text="Cancel"
        :is-loading="page.isLoading"
        @confirm="handleDelete"
        @cancel="closeDeleteConfirm"
    />

</template>

<script>

import store from '@/store/'
import {mapState} from 'vuex'
import {OTable, OPagination, OBreadCrumb, OWarningBox} from '@/components/OmnihControl'
import FeatureGate from '@/components/upsell/FeatureGate.vue'
import { computed, onMounted, reactive, ref, watch, onBeforeUnmount, nextTick } from 'vue'
import { useToast } from '@/composables/useToast'

export default {
    setup() {
        const { showToast } = useToast();
        let lastActivePage = 1;

        const meta = computed(() => store.state.Voucher.meta)

        const page = reactive({
            isLoading: false,
            output: false,
            component: 'voucher'
        });

        let fields = ref([
            'No',
            'Name',
            'Type',
            'Point',
            'Stock',
            'Min. Trx',
            'Tier',
            'Expiration',
            'Status',
            'Action'
        ]);

        const merchants = ref([]);
        const validation = ref('');

        const selectMerchant = ref();

        const selectedBusinessProfile = reactive({
            branch_id: '',
            merchant_id: '',
            corporate_id: ''
        });

        const voucherSearch = ref([]);

        const selectVoucher = ref();

        const searchSelected = ref('name');
        const searchOptions = reactive([
            { value: 'name', text: 'Name' },
            { value: 'voucher_type', text: 'Type' },
            { value: 'status', text: 'Status' },
            { value: 'tier', text: 'Tier' }
        ]);
        const searchCriteria = ref('');
        const isSearchActive = ref(false);

        const thisComponentShow = ref(true);

        const selfLoaded = ref(store.state.Auth.selfLoaded);

        const write = ref(false);

        // Whether the current user is at merchant level (has a specific merchant_id assigned)
        const isMerchantLevel = computed(() => {
            return !!selectedBusinessProfile.merchant_id;
        });
        
        // MEM-1287
        // mengembalikan true jika corporate voucher
        // mengembalikan true jika voucher merchant spesifik tapi allowed_merchants lebih dari 1
        // mengembalikan false jika voucher merchant spesifik tapi allowed_merchants hanya 1
        // Only 'specific' counts as a single-merchant voucher; any other value (including empty) is treated as corporate.
        const isCorporateVoucher = (voucher) => {
            if (!voucher) return false;
            if (voucher.merchant_scope === 'all_corporate') return true;
            if (voucher.merchant_scope === 'specific') {
                return (voucher.allowed_merchants?.length ?? 0) > 1;
            }
            return false;
        };

        // Custom Searchable & Lazy-Paginated Dropdown State
        const isMerchantDropdownOpen = ref(false);
        const merchantSearchQuery = ref('');
        const merchantRenderLimit = ref(10);
        const merchantDropdownRef = ref(null);
        const merchantSearchInputRef = ref(null);

        const filteredMerchants = computed(() => {
            if (!merchantSearchQuery.value) return merchants.value;
            const query = merchantSearchQuery.value.toLowerCase().trim();
            return merchants.value.filter(m => m.text && m.text.toLowerCase().includes(query));
        });

        const visibleMerchants = computed(() => {
            return filteredMerchants.value.slice(0, merchantRenderLimit.value);
        });

        const selectedMerchantText = computed(() => {
            const found = merchants.value.find(m => m.value === selectMerchant.value);
            return found ? found.text : "From all merchant";
        });

        const toggleMerchantDropdown = () => {
            isMerchantDropdownOpen.value = !isMerchantDropdownOpen.value;
            if (isMerchantDropdownOpen.value) {
                merchantSearchQuery.value = '';
                merchantRenderLimit.value = 10;
                nextTick(() => {
                    if (merchantSearchInputRef.value) {
                        merchantSearchInputRef.value.focus();
                    }
                });
            }
        };

        const selectMerchantOption = (val) => {
            selectMerchant.value = val;
            isMerchantDropdownOpen.value = false;
        };

        const onMerchantListScroll = (e) => {
            const el = e.target;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 15) {
                if (merchantRenderLimit.value < filteredMerchants.value.length) {
                    merchantRenderLimit.value += 10;
                }
            }
        };

        const handleOutsideClick = (e) => {
            if (merchantDropdownRef.value && !merchantDropdownRef.value.contains(e.target)) {
                isMerchantDropdownOpen.value = false;
            }
        };

        watch(
            () => store.state.Auth.selfLoaded,
            (newVal) => {
                if (newVal) {
                    selfLoaded.value = newVal;
                    loadSelectedBusinessProfile();
                }
            }
        );

        onMounted(() => {
            document.addEventListener('click', handleOutsideClick);
            store.commit('Voucher/reset_meta');
            store.commit('Voucher/clear_search');
            store.commit('Voucher/clear_filter');

            if (selfLoaded.value) {
                loadSelectedBusinessProfile();
            }
        });

        onBeforeUnmount(() => {
            document.removeEventListener('click', handleOutsideClick);
        });

        onBeforeUnmount(() => {
            const updatedMeta = { ...meta.value, page: lastActivePage };
            store.commit('Voucher/switch_page', { meta: updatedMeta });

            store.commit('Voucher/clear_search');
            store.dispatch('Voucher/read').then(() => {});
        });

        function load_state(){
            page.isLoading = true;

            // Set write permission first
            if (store.state.Auth.currUser.level === 'root') {
                write.value = true;
            } else {
                const userModules = store.state.Auth.userInfo.modules;

                if (userModules) {
                    const matchingModule = userModules.find(module => module.module_name === page.component);
                    write.value = matchingModule ? matchingModule.write : false;
                } else {
                    console.error('userModules is undefined');
                    write.value = false;
                }
            }

            return store.dispatch('Voucher/read')
            .then(function(){
                })
            .catch((err) => {
                validation.value = err.response.data.message;
                console.error(err);
            })
            .finally(()=>{
                page.isLoading = false;
                page.output=true;
            });
        }

        const isDeleteConfirmVisible = ref(false)
        const itemToDelete = ref(null)

        const confirmDelete = (item) => {
            itemToDelete.value = item
            isDeleteConfirmVisible.value = true
        }

        const closeDeleteConfirm = () => {
            isDeleteConfirmVisible.value = false
            itemToDelete.value = null
        }

        const handleDelete = () => {
            if (!itemToDelete.value) return

            page.isLoading = true

            store.dispatch('Voucher/delete', itemToDelete.value.id)
            .then(() => {
                const voucherName = itemToDelete.value.name || 'this voucher';
                const truncatedName = voucherName.length > 25 ? voucherName.substring(0, 25) + '...' : voucherName;
                showToast({
                    type: 'success',
                    title: 'Deleted',
                    message: `Voucher "${truncatedName}" has been deleted successfully.`
                });
                store.dispatch('Voucher/read')
                .then(function(){
                    })
                .catch((err) => console.error(err));
            }).catch((err) => {
                console.log(err);
                const errorMessage = err.error || err.message || err.response?.data?.error || err.response?.data?.message || 'Failed to delete voucher.';
                validation.value = errorMessage;
                showToast({
                    type: 'error',
                    title: 'Error',
                    message: errorMessage
                });
            }).finally(() => {
                page.isLoading = false;
                closeDeleteConfirm();
            });
        }

        function navPage(page){
            const _meta = {... meta.value, page}

            // console.log({page});
            // console.log({_meta});
            store.commit('Voucher/switch_page',{meta:_meta})
            load_state()
        }

        async function loadSelectedBusinessProfile() {
            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        page.isLoading = true;
                        page.output = false;

                        store.dispatch('Auth/getBusinessProfile')
                        .then((businessProfile) => {
                            selectedBusinessProfile.branch_id = businessProfile.branch_id;
                            selectedBusinessProfile.merchant_id = businessProfile.merchant_id;
                            selectedBusinessProfile.corporate_id = businessProfile.corporate_id;

                            // Corporate or Branch context: load merchant dropdown
                            if (!businessProfile.merchant_id) {
                                selectMerchant.value = "all";
                                loadMerchantsForCorporate(businessProfile);
                            } else {
                                // Merchant context: no dropdown needed
                                selectMerchant.value = businessProfile.merchant_id;
                            }

                            store.dispatch('MemberTier/read_all', businessProfile.corporate_id);

                            // Set write permission based on context
                            if (store.state.Auth.currUser.level === 'root') {
                                write.value = true;
                            } else if (businessProfile.branch_id && !businessProfile.merchant_id) {
                                // Branch context: no write access (per spec)
                                write.value = false;
                            } else {
                                const userModules = store.state.Auth.userInfo.modules;
                                if (userModules) {
                                    const matchingModule = userModules.find(module => module.module_name === page.component);
                                    write.value = matchingModule ? matchingModule.write : false;
                                } else {
                                    console.error('userModules is undefined');
                                    write.value = false;
                                }
                            }
                        })
                        .catch((err) => {
                            validation.value = err.response.data.message;
                            console.error(err);
                        })
                        .finally(async () => {
                            sessionStorage.removeItem('newVoucherAdded');
                            await load_state();
                        });

                        resolve();
                    } catch (error) {
                        reject(error);
                    }
                })();
            });
        }

        async function loadMerchantsForCorporate(businessProfile) {
            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        let rawList = [];

                        // Corporate context: load all merchants under corporate
                        if (!businessProfile.branch_id && businessProfile.corporate_id) {
                            rawList = await store.dispatch('Merchant/read_all_corporate', businessProfile.corporate_id);
                        } 
                        // Branch context: load all merchants under branch
                        else if (businessProfile.branch_id) {
                            rawList = await store.dispatch('Merchant/read_all_branch', businessProfile.branch_id);
                        }

                        if (Array.isArray(rawList)) {
                            merchants.value = [
                                { value: "all", text: "From all merchant" }, 
                                ...rawList.map((merch) => ({ 
                                    'value': merch.id, 
                                    'text': merch.name 
                                }))
                            ];
                        }

                        resolve();
                    } catch (error) {
                        reject(error);
                    }
                })();
            });
        }


        function doSearch() {
            if (!searchCriteria.value) return;

            isSearchActive.value = true;
            let search = {};
            search[searchSelected.value] = searchCriteria.value;

            if (meta.value.page !== 1) {
                lastActivePage = meta.value.page;
                const updatedMeta = { ...meta.value, page: 1 };
                store.commit('Voucher/switch_page', { meta: updatedMeta });
                store.commit('Voucher/set_search', { search });
                store.dispatch('Voucher/read').then(() => {});
            } else {
                store.commit('Voucher/set_search', { search });
                const updatedMeta = { ...meta.value, page: 1 };
                store.commit('Voucher/switch_page', { meta: updatedMeta });
                store.dispatch('Voucher/read');
            }
        }

        function clearSearch() {
            isSearchActive.value = false;
            searchCriteria.value = '';

            const updatedMeta = { ...meta.value, page: lastActivePage };
            store.commit('Voucher/switch_page', { meta: updatedMeta });

            store.commit('Voucher/clear_search');
            store.dispatch('Voucher/read').then(() => {});
        }

        function resetState() {
            searchSelected.value = 'name';
            searchCriteria.value = '';
            isSearchActive.value = false;

            store.commit('Voucher/clear_search');
            const updatedMeta = { ...meta.value, page: 1 };
            store.commit('Voucher/switch_page', { meta: updatedMeta });
            load_state();
        }

        const getStatus = (item) => {
            if (item.is_limited && Number(item.stock) <= 0) return 'Out of Stock';
            if (!item.expiration) return 'Active';
            const now = new Date();
            const expDate = new Date(item.expiration);
            if (now > expDate) return 'Expired';
            return 'Active';
        };

        const getStatusClass = (item) => {
            const status = getStatus(item);
            if (status === 'Expired') return 'status-expired';
            if (status === 'Out of Stock') return 'status-out-of-stock';
            return 'status-active';
        };

        const truncate = (text, length) => {
            if (!text) return '';
            if (text.length <= length) return text;
            return text.substring(0, length) + '...';
        };

        watch(searchSelected, () => {
            if (isSearchActive.value) {
                clearSearch();
            } else {
                searchCriteria.value = '';
            }
        });

        watch(
            () => selectMerchant.value,
            (newVal, oldVal) => {
                let filter = {};

                // Corporate context: filter by corporate_id or specific merchant
                if (!selectedBusinessProfile.branch_id && selectedBusinessProfile.corporate_id) {
                    filter = newVal === "all" 
                        ? { corporate_id: selectedBusinessProfile.corporate_id } 
                        : { merchant_id: newVal };
                } 
                // Branch context: filter by branch_id or specific merchant
                else if (selectedBusinessProfile.branch_id) {
                    filter = newVal === "all" 
                        ? { branch_id: selectedBusinessProfile.branch_id } 
                        : { merchant_id: newVal };
                } 
                // Merchant context: filter by merchant_id only
                else {
                    filter = { merchant_id: selectedBusinessProfile.merchant_id };
                }

                store.commit('Voucher/add_filter', {filter});
                
                if (oldVal !== undefined) {
                    store.dispatch('Voucher/read').then()
                    .catch((err) => {
                        validation.value = err.response.data.message;
                        thisComponentShow.value = false;
                        console.error(err);
                    })
                    .finally(() => page.output = true);
                }
            }
        )

        function formatDateOnly(dateString) {
            if (!dateString) return 'N/A';
            let dateStr = dateString;
            if (dateStr.indexOf('T') === -1 && dateStr.indexOf('Z') === -1 && dateStr.length === 19) {
                dateStr = dateStr.replace(' ', 'T');
            }
            const date = new Date(dateStr);
            const day = date.getDate().toString().padStart(2, '0');
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const monthName = months[date.getMonth()];
            const year = date.getFullYear();
            return `${day} ${monthName} ${year}`;
        }

        function formatTimeOnly(dateString) {
            if (!dateString) return '';
            let dateStr = dateString;
            if (dateStr.indexOf('T') === -1 && dateStr.indexOf('Z') === -1 && dateStr.length === 19) {
                dateStr = dateStr.replace(' ', 'T');
            }
            const date = new Date(dateStr);
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const formattedHours = hours % 12 || 12;
            const formattedMinutes = minutes.toString().padStart(2, '0');
            return `${formattedHours}:${formattedMinutes} ${ampm}`;
        }

        return {
            page,
            confirmDelete,
            handleDelete,
            closeDeleteConfirm,
            isDeleteConfirmVisible,
            itemToDelete,
            fields,
            load_state,
            meta,
            navPage,
            selectedBusinessProfile,
            merchants,
            selectMerchant,
            doSearch,
            clearSearch,
            resetState,
            voucherSearch,
            selectVoucher,
            searchSelected,
            searchOptions,
            searchCriteria,
            isSearchActive,
            validation,
            thisComponentShow,
            write,
            selfLoaded,
            getStatus,
            getStatusClass,
            truncate,
            formatDateOnly,
            formatTimeOnly,
            isMerchantLevel,
            isCorporateVoucher,
            isMerchantDropdownOpen,
            merchantSearchQuery,
            merchantRenderLimit,
            merchantDropdownRef,
            merchantSearchInputRef,
            filteredMerchants,
            visibleMerchants,
            selectedMerchantText,
            toggleMerchantDropdown,
            selectMerchantOption,
            onMerchantListScroll
        }
    },
    computed: {
        ... mapState({
            // arrow functions can make the code very succinct!
            vouchers: state => state.Voucher.vouchers,
            allTiers: state => state.MemberTier.allTiers,
        }),
        tierList() {
            let list = Array.isArray(this.allTiers)
                ? this.allTiers.map(item => ({
                    value: item.id,
                    text: item.name
                }))
                : [];
            
            return [
                { value: 'all_tiers', text: 'All Tiers' },
                ...list
            ];
        }
    },
    components:{
        OTable,
        OPagination,
        OBreadCrumb,
        OWarningBox,
        FeatureGate
    }
}
</script>

<style scoped>
/* Filter and Action Bar Styling */
.filter-action-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 20px;
    flex-wrap: wrap;
    background-color: #fff;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
}

.filter-controls {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
    flex: 1;
}

/* Custom Search Box */
.search-box-custom {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: max-content;
}

.search-type-tabs {
    display: flex;
    gap: 4px;
    background: #f1f5f9;
    padding: 4px;
    border-radius: 8px;
    width: fit-content;
    flex-wrap: wrap;
}

.tab-btn {
    border: none;
    background: transparent;
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 500;
    color: #64748b;
    border-radius: 6px;
    transition: all 0.2s;
    cursor: pointer;
}

.tab-btn.active {
    background: white;
    color: var(--primary-color, #0d6efd);
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    font-weight: 600;
}

.search-input-wrapper {
    display: flex;
    align-items: center;
    gap: 0;
    position: relative;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 0;
    transition: all 0.2s;
    height: 46px;
}

.search-input-wrapper:focus-within {
    border-color: var(--primary-color, #0d6efd);
    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);
}

.search-input-wrapper input,
.search-input-wrapper select.custom-select-transparent {
    border: none;
    padding: 10px 16px;
    font-size: 14px;
    width: 250px;
    outline: none;
    background: transparent;
    color: #334155;
    box-shadow: none;
}

.search-input-wrapper select.custom-select-transparent:focus {
    box-shadow: none;
    border: none;
}

.btn-search {
    background: #f8fafc;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
}

.search-input-wrapper .btn-search {
    position: relative;
    width: 44px;
    height: 42px;
    border-radius: 0 8px 8px 0;
    background: transparent;
}

.search-input-wrapper .btn-search:hover {
    background: #f1f5f9;
}

.status-filter-box {
    display: flex;
    align-items: center;
}

.form-control-filter {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 14px;
    height: 46px;
    min-width: 200px;
    background-color: white;
}

.form-control-filter:focus {
    border-color: var(--primary-color, #0d6efd);
    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);
    outline: none;
}

/* Action Buttons */
.action-buttons-group {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.btn-refresh {
    background-color: #fff;
    border: 1px solid #e2e8f0;
    color: #64748b;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    border-radius: 8px;
}

.btn-refresh:hover {
    background-color: #f1f5f9;
    color: #1e293b;
    border-color: #cbd5e1;
}

.btn-add {
    background-color: var(--primary-color, #0d6efd);
    color: white;
    font-weight: 600;
    font-size: 13px;
    padding: 0 20px;
    height: 40px;
    display: flex;
    align-items: center;
    border: none;
    border-radius: 8px;
    transition: all 0.2s;
    text-decoration: none;
}

.btn-add:hover {
    filter: brightness(0.9);
    color: white;
}

/* Table Styles */
.voucher-list-table {
    white-space: nowrap;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
}

.voucher-list-table th,
.voucher-list-table td {
    padding: 12px 16px !important;
    vertical-align: middle;
}

.voucher-row-clickable {
    transition: background-color 0.2s;
}

.voucher-row-clickable:hover {
    background-color: #f8fafc !important;
}

.status-active {
    background-color: #ecfdf5 !important;
    color: #065f46 !important;
    border: 1px solid #a7f3d0;
}

.status-expired {
    background-color: #fef2f2 !important;
    color: #b91c1c !important;
    border: 1px solid #fecaca;
}

.status-out-of-stock {
    background-color: #fffbeb !important;
    color: #b45309 !important;
    border: 1px solid #fde68a;
}

.status-primary {
    background-color: #eff6ff !important;
    color: #1e40af !important;
    border: 1px solid #bfdbfe;
}

.status-default {
    background-color: #f8fafc !important;
    color: #64748b !important;
    border: 1px solid #e2e8f0;
}

.status-info {
    background-color: #f0f9ff !important;
    color: #0284c7 !important;
    border: 1px solid #bae6fd;
}

/* Modern Date Formatting */
.modern-date {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.modern-date .date-main {
    font-weight: 500;
    color: #334155;
    font-size: 12px;
    white-space: nowrap;
}

.modern-date .time-sub {
    font-size: 12px;
    color: #64748b;
    display: flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
}

/* Action Buttons in Table */
.btn-action {
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 8px;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    border: none;
    cursor: pointer;
}

.btn-edit {
    background-color: #f3f4f6;
    color: #374151;
}

.btn-edit:hover {
    background-color: #e5e7eb;
    color: #111827;
}

.btn-delete {
    background-color: #fff1f2;
    color: #9f1239;
}

.btn-delete:hover {
    background-color: #ffe4e6;
    color: #be123c;
}

.badge-readonly-action {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 5px 10px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    color: #6b7280;
    background-color: #f3f4f6;
    border: 1px dashed #d1d5db;
    white-space: nowrap;
    user-select: none;
}

/* Header */
.header-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 0.25rem 0;
    display: flex;
    align-items: center;
}

.header-subtitle {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0;
    text-align: left;
}

/* Responsive */
@media (max-width: 991px) {
    .filter-action-wrapper {
        flex-direction: column;
        align-items: stretch;
        gap: 20px;
    }

    .filter-controls {
        width: 100%;
        flex-direction: column;
        align-items: stretch;
    }
    
    .search-box-custom {
        width: 100%;
    }

    .search-type-tabs {
        width: 100%;
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        padding: 6px;
        background: #f8fafc;
        scrollbar-width: none;
    }

    .search-type-tabs::-webkit-scrollbar {
        display: none;
    }

    .tab-btn {
        flex: 0 0 auto;
        white-space: nowrap;
    }

    .search-input-wrapper input,
    .search-input-wrapper select.custom-select-transparent {
        width: 100%;
    }

    .action-buttons-group {
        width: 100%;
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 12px;
    }
    
    .btn-refresh {
        width: 100%;
    }

    .btn-add {
        width: 100%;
        justify-content: center;
    }

    .status-filter-box, .form-control-filter {
        width: 100%;
    }
}

/* Custom Searchable & Lazy-Loading Merchant Dropdown Styles */
.custom-merchant-dropdown {
    position: relative;
    width: 220px;
}

.dropdown-trigger-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 38px;
    padding: 0 14px;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 13px;
    color: #1f2937;
    cursor: pointer;
    transition: all 0.2s ease;
    outline: none;
}

.dropdown-trigger-btn:hover {
    border-color: var(--primary-color, #F93E3E);
}

.trigger-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 500;
}

.trigger-icon {
    font-size: 11px;
    color: #6b7280;
    margin-left: 8px;
    transition: transform 0.2s ease;
}

.trigger-icon.is-active {
    transform: rotate(180deg);
}

.dropdown-menu-popover {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    width: 280px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05);
    z-index: 100;
    overflow: hidden;
}

.dropdown-search-box {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-bottom: 1px solid #f3f4f6;
    background: #f9fafb;
    gap: 8px;
}

.search-box-icon {
    font-size: 12px;
    color: #9ca3af;
}

.dropdown-search-input {
    flex: 1;
    border: none;
    background: transparent;
    font-size: 12px;
    color: #1f2937;
    outline: none;
    padding: 2px 0;
}

.search-clear-btn {
    border: none;
    background: transparent;
    color: #9ca3af;
    cursor: pointer;
    font-size: 11px;
    padding: 2px;
}

.dropdown-options-list {
    max-height: 220px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(209, 213, 219, 0.8) transparent;
}

.dropdown-options-list::-webkit-scrollbar {
    width: 4px;
}

.dropdown-options-list::-webkit-scrollbar-thumb {
    background: rgba(209, 213, 219, 0.8);
    border-radius: 99px;
}

.dropdown-option-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 14px;
    font-size: 13px;
    color: #374151;
    cursor: pointer;
    transition: background 0.15s ease;
}

.dropdown-option-item:hover {
    background: #f3f4f6;
    color: var(--primary-color, #F93E3E);
}

.dropdown-option-item.is-selected {
    background: rgba(249, 62, 62, 0.06);
    color: var(--primary-color, #F93E3E);
    font-weight: 600;
}

.option-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.option-check-icon {
    font-size: 11px;
    color: var(--primary-color, #F93E3E);
    margin-left: 8px;
}

.dropdown-empty-state {
    padding: 16px;
    text-align: center;
    font-size: 12px;
    color: #9ca3af;
}

.dropdown-load-more-hint {
    padding: 6px 14px;
    text-align: center;
    font-size: 11px;
    color: #9ca3af;
    background: #f9fafb;
    border-top: 1px dashed #e5e7eb;
}

@media (max-width: 768px) {
    .custom-merchant-dropdown {
        width: 100%;
    }
    .dropdown-menu-popover {
        width: 100%;
    }
}
</style>